import type { AnalyticsRange } from './analytics';

export const queryKeys = {
  me: ['users', 'me'] as const,
  tenant: ['tenant'] as const,
  customDomain: ['tenant', 'customDomain'] as const,
  portfolio: ['portfolio'] as const,
  portfolioRevisions: ['portfolio', 'revisions'] as const,
  inquiries: ['inquiries'] as const,
  inquiry: (id: string) => ['inquiries', id] as const,
  assets: ['assets'] as const,
  analyticsOverview: (range: AnalyticsRange) => ['analytics', 'overview', range] as const,
  analyticsReferrers: (range: AnalyticsRange) => ['analytics', 'referrers', range] as const,
  analyticsCountries: (range: AnalyticsRange) => ['analytics', 'countries', range] as const,
} as const;
